/***************************************************
 * Created by gongyanyu on 2023/3/29 09:56. *
 ***************************************************/
import { extendObservable, isObservableProp, observable, runInAction, set, isComputedProp } from 'mobx';
import { isRefCreator } from './initDataRef';
import { isPlainObject } from './isPlainObject';
import { mapReduce } from './mapReduce';

function isCanSerialized(obj: any): boolean {
  try {
    JSON.stringify(obj);
    return true;
  } catch (e) {
    return false;
  }
}

function getObservableFactory(value: any) {
  if (value === null || value === undefined) return observable;
  if (isRefCreator(value)) return false;
  if (Array.isArray(value) && isCanSerialized(value)) return observable;
  if (Array.isArray(value) && !isCanSerialized(value)) return observable.shallow;
  if (!isPlainObject(value)) return observable.ref;
  if (isPlainObject(value) && !isCanSerialized(value)) return observable.shallow;
  return observable;
}

export function initExtends<T>(target: Object, properties: T, keys?: string[]) {
  if (properties === undefined || properties === null) return;

  if (!isPlainObject(properties)) {
    console.error(`ERROR: $register 被一个非普通对象调用, 请修正. `, properties);
    return;
  }

  keys = keys ?? Object.keys(properties);

  if (!keys || !keys.length) return;

  const existentKeys = keys.filter((key) => isObservableProp(target, key) && !isComputedProp(target, key));
  const computedKeys = keys.filter((key) => isComputedProp(target, key));
  const nonexistentKeys = keys.filter((key) => !~existentKeys.indexOf(key) && !~computedKeys.indexOf(key));

  runInAction(() => {
    if (existentKeys.length) {
      set(
        target,
        mapReduce(existentKeys, (key) => properties[key]),
      );
    }

    if (computedKeys.length) {
      set(
        target,
        mapReduce(computedKeys, (key) => properties[key]),
      );
    }
  });

  if (nonexistentKeys.length) {
    const annotations = {} as Record<string, any>;
    const props = nonexistentKeys.reduce((oo, key) => {
      const value = properties[key as keyof T];
      annotations[key] = getObservableFactory(value);
      if (isRefCreator(value)) value(oo, key);
      else oo[key] = value;
      return oo;
    }, {} as Record<string, any>);
    extendObservable(target, props, annotations);
  }
}
